import { motion } from "framer-motion";
import AudioPlayer from "../AudioPlayer/AudioPlayer";
import InfoComponent from "./InfoComponent";
import InputComponent from "./InputComponent";
import MultipleChoiceComponent from "./MultipleChoiceComponent";
import { useContext, useState } from "react";
import { AppContext } from "../../../../Util/contexts/AppContext";
import { FadeInOut } from "../../../../Util/animations/Animations_v2";
import WritingGradeSection from "./WritingGradeSection";
import SpeakingGradeSection from "./SpeakingGradeSection";

// handleDisplayWritingFeedbackModal is no longer being used since the migration to the new writing grading. This modal and the subsequent code will need to be
// adapted down the road if feedback would like to be collected.

const GradingSection = ({
  sectionIndex,
  section,
  averageFirstAttemptGrade,
  currentlyPlayingAudioSegment,
  questionIdMap,
  gradingData,
  setCurrentlyPlayingAudioSegment,
  handleDisplayWritingFeedbackModal,
  openPDF,
  lastChecked,
  submissionTime,
  resendCaseGrade,
  resendingGrade,
}) => {
  const examGuid = gradingData.examGuid;
  const { userData, route, primaryColor } = useContext(AppContext);

  const [isSectionExpanded, setIsSectionExpanded] = useState(false);

  if (
    section.title.toLowerCase().includes("introduction") ||
    section.title.toLowerCase().includes("writing - reading only")
  )
    return null;

  const handleAudioPlay = (audioRef) => {
    // Pause the currently playing audio (if any)
    if (
      currentlyPlayingAudioSegment &&
      currentlyPlayingAudioSegment !== audioRef
    ) {
      currentlyPlayingAudioSegment.pause();
    }

    // Update the currentlyPlayingAudioSegment state
    setCurrentlyPlayingAudioSegment(audioRef);
  };

  let writingGrade = null;
  let speakingGrade = null;
  let SectionGrade = -1;

  if (section.title === "Writing") {
    gradingData.WritingGrades.forEach((value) => {
      if (value.sectionId === section.sectionId) {
        writingGrade = value;
        SectionGrade = writingGrade.sectionGrade;
      }
    });
  } else if (section.title === "Speaking") {
    gradingData.SpeakingGrades.forEach((value) => {
      if (value.sectionId === section.sectionId) {
        speakingGrade = value;
        SectionGrade = speakingGrade.sectionGrade;
      }
    });
  } else {
    const sectionGradeData = gradingData.Grade?.find(
      (gradeSection) =>
        gradeSection.Grade &&
        gradeSection.Grade.length > 0 &&
        gradeSection.Grade[0].sectionId === section.sectionId
    );

    if (sectionGradeData) {
      SectionGrade = sectionGradeData.sectionGrade;
    }
  }

  return (
    <motion.div
      className="gradingFeedbackSectionContainer"
      {...FadeInOut(userData.AnimationsDisabled, 0.2)}
      key={`gradingFeedbackSectionContainer - ${sectionIndex}`}
    >
      <div
        className="gradingFeedbackSectionHeaderWrapper"
        style={{ marginBottom: !isSectionExpanded ? 0 : 15 }}
      >
        <button
          className={
            isSectionExpanded
              ? "gradingFeedbackSectionExpandButton gradingFeedbackSectionExpandButtonOpen"
              : "gradingFeedbackSectionExpandButton"
          }
          onClick={() => setIsSectionExpanded(!isSectionExpanded)}
        />
        <div className="gradingFeedbackSectionHeaderInnerWrapper">
          <h2 className="gradingFeedbackSectionHeader">
            Section {section.sectionId} - {section.title} - (Section Grade:{" "}
            {SectionGrade?.toFixed(2)}%)
          </h2>
          <h3 className="gradingFeedbackSectionHeaderEnd">
            Average Section Grade:( {averageFirstAttemptGrade?.toFixed(2)}%)
          </h3>
          <h3 className="gradingFeedbackSectionSubheader">
            Questions {section.questionNumberStart} -{" "}
            {section.questionNumberEnd}
          </h3>
        </div>
      </div>
      {!isSectionExpanded &&
        (section.title === "Writing" ? (
          <WritingGradeSection
            writingGrade={writingGrade}
            lastChecked={lastChecked}
            resendCaseGrade={resendCaseGrade}
            sectionId={section.sectionId}
            resendingGrade={resendingGrade}
          />
        ) : section.title === "Speaking" ? (
          <SpeakingGradeSection
            speakingGrade={speakingGrade}
            lastChecked={lastChecked}
            resendCaseGrade={resendCaseGrade}
            sectionId={section.sectionId}
            resendingGrade={resendingGrade}
          />
        ) : (
          <div className="gradingFeedbackSectionBodyContainer">
            {section.Elements.map((element, elementIndex) => {
              switch (element.type) {
                case "info":
                  return (
                    <InfoComponent
                      element={element}
                      sectionIndex={sectionIndex}
                      elementIndex={elementIndex}
                      key={`infoComponent - ${sectionIndex} - ${elementIndex}`}
                    />
                  );
                case "multipleChoice":
                  return (
                    <MultipleChoiceComponent
                      element={element}
                      questionIdMap={questionIdMap}
                      key={`multipleChoiceComponent - ${sectionIndex} - ${elementIndex}`}
                      openPDF={openPDF}
                    />
                  );
                case "input":
                  return element.questionList.map((question, questionIndex) => (
                    <InputComponent
                      question={question}
                      questionIdMap={questionIdMap}
                      key={`inputComponent - ${sectionIndex} - ${elementIndex} - ${questionIndex}`}
                    />
                  ));
                case "audio":
                  if (element.audioSegments.length === 0) return null;
                  return element.audioSegments.map(
                    (audioSegment, audioSegmentIndex) => (
                      <AudioPlayer
                        audioSegment={audioSegment}
                        route={route}
                        userData={userData}
                        primaryColor={primaryColor}
                        handleAudioPlay={handleAudioPlay}
                      />
                    )
                  );
                default:
                  return null;
              }
            })}
          </div>
        ))}
    </motion.div>
  );
};

export default GradingSection;
